let currentTheme = process.env.VUE_APP_THEME || 'bestgob'

module.exports = require('./'+currentTheme)